import React from "react";

import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";

import { GreyPallet } from "../../../config/styles";

import MainText from "../../MainText";

type SelectMainProps = {
  name: string;
  startOption?: { name: string; value: string | "" };
  value: string;
  options: { name: string; value: string }[];
  onChange: (value: string) => void;
  shrink?: boolean;
};

export default function SelectMain({
  name,
  value,
  options,
  startOption,
  onChange,
  shrink = true,
}: SelectMainProps) {
  const [fieldValue, setFieldValue] = React.useState<string>(value);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const eventValue = event.target.value as string;
    setFieldValue(eventValue);
    onChange(eventValue);
  };

  return (
    <FormControl
      fullWidth
      sx={{
        mt: 1,
        "& .MuiFormLabel-root": {
          fontWeight: "bold",
          color: `${GreyPallet.RegularGhost} !important`,
        },
      }}
      variant="outlined"
    >
      <InputLabel id="simple-select-label" shrink={shrink}>
        {name}
      </InputLabel>
      <Select
        notched={shrink}
        labelId="simple-select-label"
        id="simple-select"
        value={fieldValue}
        label={name}
        onChange={handleChange}
        sx={{
          borderRadius: "15px",
          height: 60,
          fontWeight: "bold",
          fontSize: 16,
          color: GreyPallet.Regular,

          "& .MuiSvgIcon-root": {
            fontSize: 26,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: "3px !important",
            borderColor: `${GreyPallet.LightGhost} !important`,
            borderStyle: "solid",
            "& .Mui-focused": {
              borderColor: `${GreyPallet.RegularGhost} !important`,
            },
          },
        }}
      >
        {startOption ? (
          <MenuItem value={startOption.value}>
            <MainText size="caption">{startOption.name}</MainText>
          </MenuItem>
        ) : null}

        {options.map((option, index) => {
          return (
            <MenuItem key={option.value} value={option.value}>
              <MainText size="caption">{option.name}</MainText>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
